// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Input,
    InputLabel,
    Select, TextField
} from "@mui/material";

// App Imports
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {changeUsage} from "./usageSlice";
import {addUsage, editUsage} from "./UsageClient";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import {getAllProducts} from "../Product/ProductClient";
import {getAllPlatforms} from "../Platform/PlatformClient";
import {getAllLicenses} from "../License/LicenseClient";
import Stack from "@mui/material/Stack";

// Main Function
export default function UsageDrawer({contractDataPointDrawerState,contractDataPointDrawerMode}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************
    const dispatchData = useDispatch();

    const selectorUsageId = useSelector((state) => state.usageSlc.value.id);
    const selectorUsageDrawerState = useSelector((state) => state.usageSlc.value.usageDrawerState);
    const selectorUsageDrawerMode = useSelector((state) => state.usageSlc.value.usageDrawerMode);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register, handleSubmit} = useForm();


    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        // setContractDataPointId(props.contractDataPointIdX)
        console.log("here's my Usage data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorUsageDrawerMode==="Add"){
            addUsage(data)
                .then(() => {
                    console.log("Usage added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeUsage({
                    id: null, fileId: null,externalId: null, firstName: null, lastName: null,
                    ssn: null, dateOfBirth: null, dateOfDeath: null, companyName: null,
                    fein: null,dateOfDissolution:null,streetAddress:null,city:null,
                    stateProvince: null, postalCode: null, country: null, payStatus: null, status: null, stakeholderId: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    usageGridRefresh: true, usageDrawerState: false, usageDrawerMode: null}))
            })}
        if(selectorUsageDrawerMode==="Clone"){
            const { id, ...data } = data; // removes id
            addUsage(data)
                .then(() => {
                    console.log("Usage cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record cloned"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Cloning failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeUsage({id: null, fileId: null,externalId: null, firstName: null, lastName: null,
                    ssn: null, dateOfBirth: null, dateOfDeath: null, companyName: null,
                    fein: null,dateOfDissolution:null,streetAddress:null,city:null,
                    stateProvince: null, postalCode: null, country: null, payStatus: null, status: null, stakeholderId: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    usageGridRefresh: true, usageDrawerState: false, usageDrawerMode: null}))
            })}
        if(selectorUsageDrawerMode==="Edit"){
            console.log("This is the Usage Id I am going to edit")
            console.log(selectorUsageId)
            editUsage(selectorUsageId, data)
                .then(() => {
                    console.log("Usage edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("trigger refresh")
                dispatchData(changeUsage({
                    usageGridRefresh: true, usageDrawerState: false, usageDrawerMode: null}));
            })}
    };

    // ****************** END CRUD ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closeUsageDrawer() {
        dispatchData(changeUsage({usageDrawerState: false }));
    };

    // ****************** END MISC ****************************


    // *********************** BEGIN DROPDOWNS **************************


    const fetchProductsForDropdown = () =>
        getAllProducts()

            .then(data => {
                console.log("Products List")
                console.log(data);
                setProducts(data);

            })
    useEffect(() => {
        console.log("This is for the products dropdown...");
        fetchProductsForDropdown();
    }, []);


    const fetchPlatformsForDropdown = () =>
        getAllPlatforms()

            .then(data => {
                console.log("Platforms List")
                console.log(data);
                setPlatforms(data);

            })
    useEffect(() => {
        console.log("This is for the platforms dropdown...");
        fetchPlatformsForDropdown();
    }, []);


    const fetchLicensesForDropdown = () =>
        getAllLicenses()

            .then(data => {
                console.log("Licenses List")
                console.log(data);
                setLicenses(data);

            })
    useEffect(() => {
        console.log("This is for the licenses dropdown...");
        fetchLicensesForDropdown();
    }, []);


// *********************** END DROPDOWNS **************************

    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [products, setProducts] = useState([]);
    const [platforms, setPlatforms] = useState([]);
    const [licenses, setLicenses] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);


    // ****************** BEGIN FORM ****************************

    function usageForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{width: 800, height: 300, pl: 5}}
                    role="presentation"
                >

                    <h2 style={{
                        paddingLeft: 0,
                        cursor: 'pointer'
                    }} onClick={() => closeUsageDrawer()}>Usage Form</h2>
                    <h4>{selectorUsageDrawerMode} Mode</h4>
                    {/*<br/>*/}
                    {/*<br/>*/}
                    <Input
                        style={{visibility: "hidden"}}
                        {...register('id', {required: true})}
                        id="id" name="id" label="id" aria-describedby="id_entry"
                        defaultValue={Number(useSelector((state) => state.usageSlc.value.id))}
                    />
                    <br/>
                    <Stack direction="row" spacing={2}>
                    <TextField
                        {...register('externalId', {required: true})}
                        id="externalId" name="externalId" label="external ID" aria-describedby="externalId_entry"
                        defaultValue={useSelector((state) => state.usageSlc.value.externalId)}
                        sx={{width: 200}}/>
                    <TextField
                        {...register('fileId', {required: true})}
                        id="fileId" name="fileId" label="File ID" aria-describedby="fileId_entry"
                        defaultValue={useSelector((state) => state.usageSlc.value.fileId)}
                        sx={{width: 100}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <FormControl variant="standard" sx={{minWidth: 300}}>
                        <InputLabel htmlFor="propertyId">Product</InputLabel>
                        <Select

                            {...register('propertyId', {required: true})}
                            labelId="propertyId"
                            id="propertyId"
                            label="propertyId"
                            defaultValue={useSelector((state) => state.usageSlc.value.propertyId)}
                            sx={{width: 600}}
                        >
                            {products.map((ProductItem) =>
                                <MenuItem value={ProductItem.id}>{ProductItem.id}: {ProductItem.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                            <InputLabel htmlFor="platformId">Platform</InputLabel>
                            <Select

                                {...register('platformId', {required: true})}
                                labelId="platformId"
                                id="platformId"
                                label="platformId"
                                defaultValue={useSelector((state) => state.usageSlc.value.platformId)}
                                sx={{width: 300}}
                            >
                                {platforms.map((PlatformItem) =>
                                    <MenuItem value={PlatformItem.id}>{PlatformItem.name}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                        <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                            <InputLabel htmlFor="licenseId">License</InputLabel>
                            <Select

                                {...register('licenseId', {required: false})}
                                labelId="licenseId"
                                id="licenseId"
                                label="licenseId"
                                defaultValue={useSelector((state) => state.usageSlc.value.licenseId)}
                                sx={{width: 300}}
                            >
                                {licenses.map((LicenseItem) =>
                                    <MenuItem value={LicenseItem.externalId}>{LicenseItem.licensee}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Stack>
                    <br/>
                    <br/>
                    <TextField
                        {...register('stakeholderId', {required: true})}
                        id="stakeholderId" name="stakeholderId" label="Stakeholder ID" aria-describedby="stakeholderId_entry"
                        defaultValue={useSelector((state) => state.usageSlc.value.stakeholderId)}
                        sx={{width: 200}}/>
                    <br/>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('useStart', {required: false})}
                            id="useStart" name="useStart" label="Use Start" aria-describedby="useStart_entry"
                            defaultValue={useSelector((state) => state.usageSlc.value.useStart)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('useEnd', {required: false})}
                            id="useEnd" name="useEnd" label="Use End" aria-describedby="useEnd_entry"
                            defaultValue={useSelector((state) => state.usageSlc.value.useEnd)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('language', {required: false})}
                            id="language" name="language" label="Language" aria-describedby="language_entry"
                            defaultValue={useSelector((state) => state.usageSlc.value.language)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('status', {required: false})}
                            id="status" name="status" label="Status" aria-describedby="status_entry"
                            defaultValue={useSelector((state) => state.usageSlc.value.status)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            disabled={true}
                            TextField{...register('createdBy', {required: false})}
                            id="createdBy" name="createdBy" label="Created By"
                            aria-describedby="createdBy_entry"
                            defaultValue={useSelector((state) => state.usageSlc.value.createdBy)}
                            sx={{width: 200}}/>

                        <TextField
                            disabled={true}
                            {...register('createdOn', {required: false})}
                            id="status" name="createdOn" label="Created On"
                            aria-describedby="createdOn_entry"
                            defaultValue={useSelector((state) => state.usageSlc.value.createdOn)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedBy', {required: false})}
                            id="lastModifiedBy" name="lastModifiedBy" label="Last Modified By"
                            aria-describedby="lastModifiedBy_entry"
                            defaultValue={useSelector((state) => state.usageSlc.value.lastModifiedBy)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedOn', {required: false})}
                            id="lastModifiedOn" name="lastModifiedOn" label="Last Modified On"
                            aria-describedby="lastModifiedOn_entry"
                            defaultValue={useSelector((state) => state.usageSlc.value.lastModifiedOn)}
                            sx={{width: 200}}/>
                    </Stack>

                    <br/>
                    <br/>
                    <Button
                        type="submit"
                    >Submit</Button>
                    <Button onClick={() => closeUsageDrawer()}>Cancel</Button>
                    <HiddenFields/>
                </Box>
            </form>
        );
    }

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>

            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorUsageDrawerState}
                onClose={closeUsageDrawer}
            >
                {usageForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
